<template>
    <div class="panel panel-default" v-if="item.about">
        <div class="panel-body form-horizontal">
            <h5 class="t_uppercase bold m-t-0">{{ item.fancy_name }}</h5>
            <div v-html="about"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Supplier',
        props: ['item'],
        computed: {
            about () {
                return this.$options.filters.pmlNl2br(this.item.about) || ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Suppliers.vue